import React, { FC } from "react";
import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { GoBack } from "../View/GoBack";
import { InsuranceErrorParams } from "../../../Pages/InsuranceError/InsuranceErrorParams.csharp";

export const ErrorPage: FC<InsuranceErrorParams> = (props) => {
  const { buttons, headings } = useInsuranceLabels();

  return (
    <div className="insuranceErrorPage insuranceErrorPageWrapper">
      <div className="insuranceErrorPage__content">
        <h1 className="insuranceErrorPage__header">
          {headings.siteUnavailableTitle}
        </h1>
        <span className="insuranceErrorPage__subHeader">
          {headings.siteUnavailableSubTitle}
        </span>
        <GoBack label={buttons.goToListViewButtonLabel} />
      </div>
      <div className="insuranceErrorPage__sidePanel">
        <div className="insuranceErrorPage__sidePanelIconWrapper">
          <span className="insuranceErrorPage__sidePanelIcon icon-sad-face"></span>
        </div>
      </div>
    </div>
  );
};
